import React, { Suspense } from 'react';
import { useLocation } from 'react-router';
import { PermissionedView } from '@cvt/components/Permissioned';
import { ListLoading } from '@cvt/components/layout/ListLoading';
import { useNextAssertion } from '@modules/Assertions/hooks/useNextAssertion';
import { NoAssertions } from '@pages/Assertions/NoAssertions';
import { Paper } from '@mui/material';
import { InfiniteMajorsList } from '../partials/InfiniteMajorsList';
import { MajorRow, MajorRowSkeleton } from '../components/MajorRowWithOptions';

interface ViewProps {}

export const Majors: React.FC<ViewProps> = () => {
  const location = useLocation();
  const { next } = useNextAssertion();

  const [dismissNoAssertions, setDismissNoAssertions] = React.useState(false);

  const shouldShowNoAssertions =
        !dismissNoAssertions && ((next?.totalAnswered ?? 0) <= 10);

  return (
    <PermissionedView permission="majors.list">
      {shouldShowNoAssertions ? (
        <NoAssertions
          objectKey="majors"
          onSeeList={() => setDismissNoAssertions(true)}
        />
      ) : (
        <Paper
          variant="elevation"
          elevation={1}
          sx={{ overflow: 'hidden', width: '100%' }}
        >
          <Suspense
            key={location.key}
            fallback={
              <ListLoading
                disablePadding
                repeat={10}
                renderItem={() => <MajorRowSkeleton />}
              />
            }
          >
            <InfiniteMajorsList
              renderItem={(major) => <MajorRow key={major.id} {...major} />}
              renderSkeleton={() => <MajorRowSkeleton />}
            />
          </Suspense>
        </Paper>
      )}
    </PermissionedView>
  );
};